<template>
  <ul class="cs-1depth" id="g-contents">
    <li v-for="(tab, index) in tabList" :key="index" :class="setTabCss(tab.name)">
      <router-link :to="tab.link">{{tab.title}}</router-link>
    </li>
  </ul>
</template>

<script>
export default {
  data () {
    return {
      tabList: [ // https://member.wavve.com/customer/qna/ask
        { title: '공지사항', link: '/customer/notice_list', name: 'notice' },
        { title: '자주 묻는 질문 FAQ', link: '/customer/faq', name: 'faq' },
        { title: '1:1 문의', link: '/customer/user_qna', name: 'user_qna' },
        { title: '이용약관', link: '/customer/agreement', name: 'agreement' }
      ]
    }
  },
  methods: {
    setTabCss (tab) {
      return this.$route.meta.tab === tab ? 'customer-1depth-on' : ''
    }
  }
}
</script>
